module.exports = __webpack_public_path__ + "img/clapperboard.136f3614.png";